<template>
  <div class="page-full">
    <div class="container auth__container">
      <div v-if="step === 1" class="auth">
        <form @submit.prevent="submitForm()" class="auth-form">
          <h2 class="mb-4">Box Office</h2>
          <hr />
          <br />
          <div class="text-left">
            <div class="form-group mb-4">
              <div class="mp-form-text">
                <div class="input-container">
                  <input v-model.trim="user.username" type="email" required />
                  <label>Email</label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="mp-form-text" :class="viewPassword ? 'active' : ''">
                <div class="input-container with-icon">
                  <input v-model.trim="user.password" :type="viewPassword ? 'text' : 'password'" required />
                  <label>Contraseña</label>
                  <ViewPassword @click.native="viewPassword = !viewPassword" />
                </div>
              </div>
            </div>
          </div>
          <p v-if="error" class="small text-danger">{{ error }}</p>
          <div class="mt-4 text-left">
            <button type="button" class="mp__btn transparent btn-password" @click="viewChangePassword">
              Olvidaste tu contraseña?
            </button>
          </div>
          <div class="mt-4">
            <button type="submit" :disabled="loading" class="mp__btn btn-primary btn-lg btn-block">
              {{ loading ? 'Verificando...' : 'Iniciar sesión' }}
            </button>
          </div>
        </form>
      </div>
      <div class="auth-password">
        <form v-if="step === 2" @submit.prevent="submitFormEmail(resetEmail)" class="auth-form">
          <h2 class="mb-4">Restablecer contraseña</h2>
          <div class="text-left">
            Ingresa tu correo electrónico registrado y te enviaremos un enlace para restablecer tu contraseña.
          </div>
          <hr />
          <br />
          <div class="form-group mb-4" :class="{ error: message != '' && resetEmail != '' }">
            <div class="mp-form-text">
              <div class="input-container">
                <input v-model.trim="resetEmail" type="email" required />
                <label>Email</label>
              </div>
            </div>
            <p v-if="message != '' && resetEmail != ''" style="font-size: 0.75rem; font-weight: 500">{{ message }}</p>
          </div>
          <div class="mt-4">
            <button type="submit" :disabled="loading" class="mp__btn btn-primary btn-lg btn-block">
              {{ loading ? 'Enviando...' : 'Enviar' }}
            </button>
          </div>
        </form>
        <div v-if="step === 3" class="auth-form">
          <h2 class="mb-4">Revisa tu correo</h2>
          <div class="text-left">
            Se ha enviado un correo a {{ this.resetEmail }} con instrucciones para reiniciar tu contraseña
          </div>
          <hr />
          <br />
          <button type="button" @click="returnLogin" class="mp__btn btn-primary btn-lg btn-block">Regresar</button>
        </div>
      </div>
      <div v-if="step === 4" class="auth">
        <div class="auth-form-otp">
          <LoginVerification
            :user="otpVerify"
            :userPriv="user"
            @success="onSuccessVerification"
            @cancel="step = 1"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ViewPassword } from '@/assets/icons';
import api from '../api';
import LoginVerification from '../components/auth/LoginVerification.vue';
export default {
  components: { ViewPassword, LoginVerification },
  data() {
    return {
      loading: false,
      user: {
        username: '',
        password: '',
      },
      error: '',
      viewPassword: false,
      resetEmail: '',
      step: 1,
      message: '',
      captcha: 'joinnus4ever',
      otpVerify: null,
      userLog: null
    };
  },
  methods: {
    async setError() {
      const loginMessage = await this.$store.getters.getLoginMessage;
      let message = 'Error, datos incorrectos!';
      if (loginMessage) {
        message = loginMessage;
      }
      this.error = message;
      setTimeout(() => {
        this.error = '';
      }, 5000);
    },
    async submitForm() {
      try {
        localStorage.removeItem("availablePos");
        this.$store.dispatch('setPosData', true);
        const { dispatch } = this.$store;
        const data = new window.FormData();
        data.append('email', this.user.username);
        data.append('password', this.user.password);
        this.loading = true;
        if (this.captcha === null) {
          return null
        }
        const hasLogin = await dispatch('login', { payload: data, captcha: this.captcha });
        this.userLog = hasLogin
        if (!hasLogin.status) {
          if (hasLogin.message) {
            this.setError(hasLogin.message);
          } else {
            this.setError('Correo o contraseña incorrectos');
          }
        } else if (hasLogin.isOTPRequired) {
          const { user } = this
          this.otpVerify = {
            access: user,
            ...hasLogin.profile,
            ...hasLogin.user,
            token: hasLogin.token
          }
          this.step = 4;
        }
         else {
          this.$store.commit('login', hasLogin )
          this.$router.push(this.$route.query.redirect || '/');
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    viewChangePassword() {
      this.step = 2;
    },
    async submitFormEmail(resetEmail) {
      let res = await api.forgotPassword(resetEmail);
      if (res.data.status == true) {
        this.step = 3;
      } else {
        this.message = res.data.message;
        setTimeout(() => {
          this.message = '';
        }, 2500);
      }
    },
    returnLogin() {
      this.resetEmail = '';
      this.step = 1;
    },
    getCaptcha(){
      if (window && window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(process.env.VUE_APP_GOOGLE_RECAPCHA_SITE_KEY, { action: 'submit' }).then((token) => {
            this.captcha = token;
          });
        });
      }
    },
    onSuccessVerification({ session }) {
      this.inLoginVerification = false;
      const { userLog } = this
      this.$store.commit('login', {
        ...userLog,
        token: session
      });
      this.$router.push(this.$route.query.redirect || '/');
    },
  },
};
</script>
<style lang="scss" scoped >
.auth-form-otp {
  text-align: center;
  max-width: 30rem;
  margin: auto;
  border-radius: 0.5rem;
}
</style>